import { render, staticRenderFns } from "./SwitchBase.vue?vue&type=template&id=76c97bf0&"
import script from "./SwitchBase.vue?vue&type=script&lang=js&"
export * from "./SwitchBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports